import React, { Fragment } from 'react';

import { BackgroundType } from '@zola/zola-ui/src/components/PreAuthV3/FeaturedImage';
import Masthead from '@zola/zola-ui/src/components/PreAuthV3/Masthead';

import P from '@zola/zola-ui/src/typography/Paragraphs';
import T from '@zola/zola-ui/src/typography/Text';

import desktopAsset from '../../../../../../public/static-preauth/images/PaperLP/v3/NickViall/nickAndNatalieInvite@2x.jpg';
import mobileAsset from '../../../../../../public/static-preauth/images/PaperLP/v3/NickViall/nickAndNatalieInvite.jpg';

export const NickViallMasthead: React.FC = () => (
  <Masthead
    title={
      <h2>
        The <span>Viall</span> style
      </h2>
    }
    images={{
      background: {
        parameters: {
          alt: 'Invitation cards featuring Nick Viall and Natalie Joy',
          featuredSrc: desktopAsset,
          jpg: [
            { url: mobileAsset, breakpoint: '768' },
            { url: desktopAsset, breakpoint: '1200' },
          ],
        },
        type: BackgroundType.IMAGE,
      },
    }}
    content={
      <Fragment>
        <P.BodyLarge data-testid="viall-collection">
          <T.Strong>Nick Viall</T.Strong> and <T.Strong>Natalie Joy</T.Strong> asked us for
          &quot;vogue-on-a-farm&quot; save the dates & invites, and we&apos;re obsessed for all the
          right reasons.
        </P.BodyLarge>
        <br />
        <P.BodyLarge>Shop their stunning suite only at Zola.</P.BodyLarge>
      </Fragment>
    }
    btnText="Customize yours"
    btnHref="/wedding-planning/invitations/8b476596-4a13-4b3e-9b0a-5c149a2da9af"
    isPhotoOnRight
  />
);
